export default "__VITE_ASSET__BHTP3bf___"